import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAllExams, removeExamById, saveExam } from './examThunk';

interface ExamState {
  exams: any[];
  loading: boolean;
  error: string | null;
}

const initialState: ExamState = {
  exams: [],
  loading: false,
  error: null,
};

const examSlice = createSlice({
  name: 'exam',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllExams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllExams.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.exams = action.payload;
      })
      .addCase(fetchAllExams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch exams';
      })

    builder
      .addCase(saveExam.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveExam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to save exam';
      })
      .addCase(saveExam.fulfilled, (state) => {
        state.loading = false;
      })

    builder
      .addCase(removeExamById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeExamById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to remove exam by id';
      })
      .addCase(removeExamById.fulfilled, (state) => {
        state.loading = false;
      })
    // builder
    //   .addCase(fetchExamById.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    //   })
    //   .addCase(fetchExamById.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.error.message || 'Failed to fetch exam by id';
    //   })
    //   .addCase(fetchExamById.fulfilled, (state, action: PayloadAction<any>) => {
    //     if (!action.payload.id) {
    //       return;
    //     }

    //     const index = state.exams.findIndex(o => o.id === action.payload.id);
    //     if (index !== -1) {
    //       state.exams[index] = action.payload;
    //     } else {
    //       state.exams.push(action.payload);
    //     }
    //   })
  },
});

export default examSlice.reducer;
